/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from 'modules/common/Link';
import Portals from 'modules/common/Portals';
import React from 'react';
import Emoji from 'react-emoji-render';
import {FormattedMessage, useIntl} from 'react-intl';
import BarmejLogo from 'theme/assets/images/barmej-white-logo.svg';
import KfasLogo from 'theme/assets/images/kfas-white-logo.svg';

const {PARTNER} = process.env;

const ShouldRegisterModal = () => {
  const intl = useIntl();
  const {formatMessage} = intl;
  return (
    <Portals>
      <div className="tc flex items-center justify-center fixed top-0 left-0 right-0 bottom-0 bg-black-90 z-9999 ph3">
        <div className="br2 mw6">
          <div
            className="pa3 h5 flex flex-column justify-between items-center white tc"
            style={{backgroundColor: '#5fa5ef'}}
          >
            <div />
            <h1>
              <FormattedMessage id="register_modal_title" />
            </h1>
            {PARTNER === 'KFAS' && (
              <img src={KfasLogo} width="150" alt="kfas logo" />
            )}
            {PARTNER === 'BARMEJ' && (
              <img src={BarmejLogo} width="150" alt="barmej logo" />
            )}
          </div>
          <div className="ph3 pv2 bg-white">
            <h2 className="pv3 black">
              <FormattedMessage id="register_modal_subtitle" />
            </h2>
            <p className="pb3 gray">
              <Emoji
                text={formatMessage({
                  id: 'register_modal_description',
                })}
              />
            </p>
            <div className="ph3-ns pv2 center flex justify-center">
              <Link
                to="/auth/register"
                title={formatMessage({
                  id: 'sign_up',
                })}
                className="grow no-underline white mh2 dib pa2-ns pv1 ph3-ns br-pill ttu"
                style={{backgroundColor: '#5eaef9'}}
              >
                <FormattedMessage id="sign_up" />
              </Link>
              <Link
                to="/auth/login"
                title={formatMessage({id: 'sign_in'})}
                className="grow no-underline black dib mh2 pa2-ns ph3-ns pv1 br-pill b--black ba ttu"
              >
                <FormattedMessage id="sign_in" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Portals>
  );
};

export default ShouldRegisterModal;
